import { useParams } from "react-router-dom";
import { SharedInterfaceMonthlyReports } from "../../home/fleet/monthlyReports/sharedInterface";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import { mileageGapReportFileExportForDepartmentUserAsync } from "../../home/fleet/fleetSlice";

export const MonthlyReportsTab = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const department = useAppSelector(selectCurrentDepartment);

  const handleDownloadReportFile = (reportFileUuid: string) => {
    if (!department) return;

    void dispatch(
      mileageGapReportFileExportForDepartmentUserAsync({
        reportFileUuid,
        departmentUuid: department.uuid,
      }),
    );
  };

  if (params.tab !== "monthly_reports") {
    return;
  }

  return (
    <SharedInterfaceMonthlyReports
      canGenerateReports={false}
      downloadReportFileAction={handleDownloadReportFile}
    />
  );
};
